import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../config";
import { headerConfig } from "../../functions/headerConfig";

export const esFormApi = createApi({
    reducerPath: 'esForm/api',
    baseQuery: fetchBaseQuery({
        baseUrl: config.apiUrl,
        prepareHeaders: (headers) => headerConfig(headers),
    }),
    endpoints: build => ({
        getData: build.query<any, string>({
            query: (query: string) => {
                return {
                    url: `/generation/info/em/${query}`
                }
            },
        }),
        generateReport: build.query<any, string>({
            query: (query: string) => {
                return {
                    url: `/generation/docs/em/${query}`
                }
            },
        }),
    })
})

export const { useLazyGetDataQuery, useLazyGenerateReportQuery } = esFormApi;
